import { render, staticRenderFns } from "./MemberCenterAdminEmailArchiveTable.vue?vue&type=template&id=223d8904&scoped=true&lang=pug&"
import script from "./MemberCenterAdminEmailArchiveTable.vue?vue&type=script&lang=js&"
export * from "./MemberCenterAdminEmailArchiveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223d8904",
  null
  
)

export default component.exports